import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';

function FormLabel(_ref) {
  let {
    className,
    children,
    label,
    labelPosition,
    margin,
    fullWidth
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "children", "label", "labelPosition", "margin", "fullWidth"]);

  let cssClasses = ['st_label', "st_label--" + labelPosition];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  if (fullWidth) cssClasses.push('st_label--fullWidth');
  return (
    /*#__PURE__*/

    /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
    React.createElement("label", _extends({
      className: cssClasses.join(' ')
    }, otherProps), " ", /*#__PURE__*/React.createElement("div", {
      className: "st_label__text"
    }, label), children)
  );
}

FormLabel.propTypes = {
  /** extra CSS classes, if any */
  className: classNameProps,

  /** what to display as the label content */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /** position of label relative to input */
  labelPosition: PropTypes.oneOf(['top', 'left', 'right', 'bottom']),

  /** margin for label, if any */
  margin: marginProps,

  /** whether label should take up all available space */
  fullWidth: PropTypes.bool
};
FormLabel.defaultProps = {
  className: null,
  labelPosition: 'top',
  margin: null,
  fullWidth: false
};

export default FormLabel;
